import { render, staticRenderFns } from "./TrTestBooleanV2.vue?vue&type=template&id=71ddaf28&scoped=true&"
import script from "./TrTestBooleanV2.vue?vue&type=script&lang=js&"
export * from "./TrTestBooleanV2.vue?vue&type=script&lang=js&"
import style0 from "./TrTestBooleanV2.vue?vue&type=style&index=0&id=71ddaf28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ddaf28",
  null
  
)

export default component.exports